import React from 'react';

import {SPREADSHEET_MIME_TYPE} from 'bulk-import/SpreadsheetBulkImportConstants';
import {AutomationFileErrors} from 'lab-automation/automation-files/AutomationFileStatusModal';
import FileChooser from 'ui-library/FileChooser';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {TransformPreviewFile} from '../RunSchemaSpecConstants';
import CSVFilePreview from './CSVFilePreview';

interface TransformPreviewProps {
  baseFileUrl: string | null;
  previewFile: TransformPreviewFile | null;
  isLoading: boolean;
  setBaseFile: (file: File) => void;
}

export default function TransformPreview(props: TransformPreviewProps): JSX.Element {
  const {baseFileUrl} = props;
  if (props.isLoading) {
    return <CenteredHorizontalThrobber />;
  }
  if (baseFileUrl == null) {
    return <FileChooser accept={SPREADSHEET_MIME_TYPE} multiple={false} onSelectFiles={props.setBaseFile} />;
  }
  if (props.previewFile == null) {
    return <CSVFilePreview url={baseFileUrl} maxRows={500} />;
  }
  if (props.previewFile.url != null) {
    return <CSVFilePreview url={props.previewFile.url} maxRows={500} />;
  } else {
    return <AutomationFileErrors errors={props.previewFile.errors} schemaIds={{}} />;
  }
}
